import {
  IRoute,
  IRouteState,
} from '@interfaces/App.interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { goToRoute, updateLastBread } from '@redux/slices/states/router/utils/routes.utils';
import App from '@gral/app';
import { globalActions } from '../global/globalSlice';

export interface Router {
  historyRoutes: IRoute[];
}
type RouterKey = keyof Router;

const initialState: Router = {
  historyRoutes: App.cxStore.loadHistoryRoutes() || [], //List of routes

};

export const routerSlice = createSlice({
  name: 'router',
  initialState,
  reducers: {
    addRouteInHistoryRoute(state, action: PayloadAction<{ route: IRoute; options?: IRouteState; browserNewTabData?: any }>) {
      const { route, options, browserNewTabData } = action.payload;
      route.pageComponent = null;
      state.historyRoutes = goToRoute(state.historyRoutes, route, options);

      if (browserNewTabData) {
        console.log('Updating last step bread crumb');
        state.historyRoutes = updateLastBread(state.historyRoutes, browserNewTabData);
      }
      localStorage.setItem('historyRoutes', JSON.stringify(state.historyRoutes));
      sessionStorage.setItem('historyRoutes', JSON.stringify(state.historyRoutes));
    },
    updateLastBreadHistoryRoute(state, action: PayloadAction<{ options: IRouteState }>) {
      const { options } = action.payload;

      state.historyRoutes = updateLastBread(state.historyRoutes, options);
    },
    clearHistoryRoutes(state) {
      state.historyRoutes = [];
    },
  },
  extraReducers: builder => {
    builder.addCase(globalActions.logout, state => {
      state.historyRoutes = [];
      localStorage.removeItem('historyRoutes');
      sessionStorage.removeItem('historyRoutes');
    });
  },
});

export const routerActions = routerSlice.actions;

export const routerSelectors = (state: Router) => state;
